import React from "react";

// ASSETS
import Illustration from "assets/svg/CollabIllustration.svg";

// STYLES
import {
  BodyContainer,
  ButtonContainer,
  FirstParagraph,
  IllustrationMobileWrapper,
  IllustrationWrapper,
  InfoSection,
  ParentContainer,
  SecondParagraph,
  Title,
  ButtonWrapper,
} from "./CollabSectionStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// MISC
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import useWindowWidth from "hooks/useWindowWidth";
import { IProps } from "./CollabSectionModel";
import { appRoutes } from "config/AppRoutesConfig";

// REDUX

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import CustomText from "components/Atoms/CustomText/CustomText";

const CollabSection: React.FC<IProps> = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS

  const { t } = useTranslation();
  const navigate = useNavigate();

  // STATE CONSTANTS
  const windowWidth = useWindowWidth();

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <ParentContainer>
      {windowWidth > 1227 && (
        <Title>
          <CustomText
            type={TextType.H2}
            text={t("view.collabSection.colaborate")}
            color={COLORS.VividAuburn}
          />
        </Title>
      )}
      <BodyContainer>
        {windowWidth > 1227 && (
          <IllustrationWrapper src={Illustration} alt="" />
        )}
        {windowWidth < 1228 && (
          <CustomText
            type={TextType.H2}
            text={t("view.collabSection.colaborate")}
            color={COLORS.VividAuburn}
          />
        )}
        {windowWidth < 1228 && (
          <IllustrationMobileWrapper src={Illustration} alt="" />
        )}

        <InfoSection>
          <FirstParagraph>
            <CustomText
              type={TextType.P1}
              text={t("view.collabSection.firstText")}
              color={COLORS.RaisinBlack}
            />
            <CustomText
              type={TextType.P1}
              text={"rezilienta.dgpc@mai.gov.ro"}
              color={COLORS.VividAuburn}
            />
          </FirstParagraph>

          <SecondParagraph>
            <CustomText
              type={TextType.P1}
              text={t("view.collabSection.secondText")}
              color={COLORS.RaisinBlack}
            />
          </SecondParagraph>
        </InfoSection>

        <ButtonContainer>
          <ButtonWrapper>
            <ButtonAtom
              text={t("view.collabSection.seePartners")}
              type={ButtonType.RedButton}
              hasArrow={true}
              onClick={() => navigate(appRoutes.partners)}
            />
          </ButtonWrapper>
        </ButtonContainer>
      </BodyContainer>
    </ParentContainer>
  );
};

export default CollabSection;
